import { Box, Typography } from "@mui/material";
import { colors } from "../../../theme/palette";
import { useTranslation } from "react-i18next";
import { DashboardV2Icon } from "../../../assets/icons/MUI/DashboardIcons";
import Audience from "./Audience";
import AudienceLocation from "./AudienceLocation";
import { useState } from "react";
import { useQueryAudienceData } from "../../../api/queries/dashboard/useQueryHumanResources";

const HumanResourcesV2 = () => {
  const { t } = useTranslation();
  const [location, setLocation] = useState<"CITY" | "COUNTRY">("CITY");

  const { audienceByLocationData, isAudienceByLocationDataLoading, followersPerAgeData, isFollowersPerAgeDataLoading } =
    useQueryAudienceData(location);

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: colors.White,
        width: "100%",
        minHeight: "495px",
        padding: "26px 20px",
      }}
    >
      <Typography
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          color: colors.Black100,
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          marginBottom: "8px",
        }}
      >
        <DashboardV2Icon />
        {t("pages.dashboard.humanResources")}
      </Typography>
      <Typography
        sx={{
          color: colors.Dark600,
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "24px",
          marginBottom: "37px",
        }}
      >
        {t("pages.dashboard.valuesBasedTotalFollowers")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Audience dataset={followersPerAgeData?.data} isLoading={isFollowersPerAgeDataLoading} />
        <AudienceLocation
          data={audienceByLocationData?.data?.result || []}
          location={location}
          setLocation={setLocation}
          isLoading={isAudienceByLocationDataLoading}
        />
      </Box>
    </Box>
  );
};

export default HumanResourcesV2;
